import { useAuth } from './context/AuthContext';
import SignIn from './pages/SignIn';
import FieldHome from './pages/field/FieldHome';

// Field mode: a full-screen, touch-first view for dispatched staff. Reuses the staff session.
export default function FieldApp() {
  const { status } = useAuth();
  if (status === 'loading') return <div className="boot">Loading…</div>;
  if (status !== 'authed') return <SignIn />;
  return <FieldHome />;
}
